/**
 * ID Generation Utilities
 *
 * Uses crypto.randomUUID() for unique identifiers.
 * Falls back to timestamp-based ID if crypto is unavailable.
 */

/**
 * Generate a unique ID using crypto.randomUUID().
 * Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers (unlikely in modern PWA)
  return generateFallbackId();
}

/**
 * Fallback ID generation using timestamp + random.
 * Less collision-resistant than UUID but works everywhere.
 */
function generateFallbackId(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 10);
  return `${timestamp}-${random}`;
}

/**
 * Validate if a string is a valid UUID v4 format.
 */
export function isValidUUID(id: string): boolean {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}
